import { createContext, useCallback, useMemo, useState } from 'react';

export const StepperContext = createContext({});

const StepperProvider = ({ children, steps = [], initialStep = 0 }) => {
  const [current, setCurrent] = useState(initialStep);

  const nextStep = useCallback(() => {
    const next = current + 1;
    if (!steps[next]) {
      console.error('No steps ahead');
      return undefined;
    }
    setCurrent(next);
  }, [current, steps]);

  const prevStep = useCallback(() => {
    const prev = current - 1;
    if (!steps[prev]) {
      console.error('No previous steps');
      return undefined;
    }

    setCurrent(prev);
  }, [current, steps]);

  const backToStart = useCallback(() => {
    setCurrent(initialStep);
  }, []);

  const contextValue = useMemo(
    () => ({
      currentStep: steps[current],
      currentStepInd: current,
      nextStep,
      prevStep,
      steps,
      backToStart,
    }),
    [current, nextStep, prevStep, steps, backToStart]
  );

  return (
    <StepperContext.Provider value={contextValue}>
      {children}
    </StepperContext.Provider>
  );
};

export default StepperProvider;
